module.exports = __webpack_public_path__ + "img/big.35740120.jpg";